<template>
  <div>
    <span
      class="tertiary--text font-weight-bold text-uppercase text-overline sidebar-list__title"
    >
      {{ renderActiveOrganizationName() }}
    </span>
    <span
      v-if="$route.params.playerId && activePlayer"
      class="font-weight-bold player-name-title"
    >
      {{ " : &nbsp; " + activePlayer.firstName + " " + activePlayer.lastName }}
    </span>

    <div class="storage__navigation-breadcrumbs d-flex align-center">
      <div class="d-flex align-center">
        <AssignmentsAndFilesNavigationLink
          v-for="navigationLink in navigationLinks"
          :key="navigationLink.label"
          :label="navigationLink.label"
          @handleClick="handleNavigationLinkClick"
        />
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import { ModuleTypes } from "@/store/ModuleTypes";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ACADEMY_PREFIX, Routes } from "@/router/Routes";
import { isAdminRole } from "@/helpers/userRole.utils";
import AssignmentsAndFilesNavigationLink from "@/views/academy/common/AssignmentsAndFilesNavigationLink";
import { i18n } from "@/plugins/i18n";

export default {
  name: "AssignmentsAndFilesNavigation",
  components: { AssignmentsAndFilesNavigationLink },
  props: {
    isShowAdminFolders: {
      type: Boolean,
      default: false
    },
    setIsShowAdminFoldersRootLevel: {
      type: Function,
      default: null
    },
    handleSearchingInfoShow: {
      type: Function,
      default: null
    }
  },
  data: () => ({
    ACADEMY_ASSIGNMENT: Routes.ACADEMY_ASSIGNMENT_ORGANIZATION.path
  }),
  computed: {
    ...mapGetters(ModuleTypes.STORAGE, ["activeOrganization", "activePlayer"]),
    ...mapGetters(ModuleTypes.AUTH, ["userRoles"]),
    ...mapGetters(ModuleTypes.ACADEMY_NAVIGATOR, ["organizations"]),

    renderFilesRoute: function() {
      if (isAdminRole(this.userRoles)) {
        return this.$route.params?.teamId
          ? `${ACADEMY_PREFIX}/storage/${this.$route.params?.orgId}/${this.$route.params.teamId}/organization`
          : `${ACADEMY_PREFIX}/storage/${this.$route.params?.orgId}/organization`;
      } else {
        return `${Routes.ACADEMY_STORAGE_ORGANIZATION.path}/${this.activeOrganization?.id}/player/${this.activePlayer?.playerId}`;
      }
    },

    navigationLinks() {
      return [
        {
          label: i18n.tc("storage.assignments")
        },
        {
          label: i18n.tc("storage.files")
        }
      ];
    }
  },
  methods: {
    ...mapMutations(ModuleTypes.STORAGE, [
      "setStorageSearchInputValue",
      "setStorageSearchInputFocused",
      "setStorageBreadcrumbs"
    ]),
    ...mapActions(ModuleTypes.STORAGE, ["fetchStorageContent"]),

    renderActiveOrganizationName() {
      if (this.$route.params?.playerId) {
        return this.activePlayer?.organizationName;
      } else {
        return this.activeOrganization?.name;
      }
    },

    handleNavigationLinkClick(label) {
      this.setStorageBreadcrumbs([]);
      if (label === i18n.tc("storage.assignments")) {
        if (this.$route.params?.playerId) {
          return this.$router.push(
            `${Routes.ACADEMY_ASSIGNMENT.path}/${this.activePlayer?.organizationId}/player/${this.activePlayer.playerId}`
          );
        } else if (this.$route.params?.teamId) {
          return this.$router.push(
            `${ACADEMY_PREFIX}/assignment/${this.$route.params.orgId}/${this.$route.params.teamId}/organization`
          );
        } else {
          return this.$router.push(
            `${ACADEMY_PREFIX}/assignment/${this.$route.params.orgId}/organization`
          );
        }
      } else if (label === i18n.tc("storage.files")) {
        this.handleSearchingInfoShow && this.handleSearchingInfoShow();
        this.setStorageSearchInputValue("");
        this.setStorageSearchInputFocused(false);
        if (this.setIsShowAdminFoldersRootLevel) {
          this.setIsShowAdminFoldersRootLevel(this.isShowAdminFolders);
        }
        if (this.activePlayer && !this.$route.params.orgId) {
          this.$router.push(
            `${Routes.ACADEMY_STORAGE_ORGANIZATION.path}/${this.activePlayer?.organizationId}/player/${this.activePlayer?.playerId}`
          );
        } else if (this.$route.params.teamId) {
          this.$router.push(
            `${ACADEMY_PREFIX}/storage/${this.$route.params?.orgId}/${this.$route.params.teamId}/organization`
          );
        } else {
          this.$router.push(
            `${ACADEMY_PREFIX}/storage/${this.$route.params?.orgId}/organization`
          );
        }
        return this.fetchStorageContent({
          organizationId:
            this.activePlayer && !this.$route.params.orgId
              ? this.activePlayer?.organizationId
              : this.activeOrganization?.id,
          parentId: null,
          playerId: this.activePlayer ? this.activePlayer?.playerId : null,
          isStorageBreadcrumbs: true,
          rootDirectory: true,
          orgAdmins: this.isShowAdminFolders
        });
      }
    }
  }
};
</script>

<style scoped></style>
